module.exports = __webpack_public_path__ + "static/img/合照1.613f81a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照1.jpg
// module id = EdgG
// module chunks = 1